'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _update = require('react/lib/update');

var _update2 = _interopRequireDefault(_update);

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _Card = require('./Card');

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriorityModal = (_dec = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PriorityModal, _Component);

  function PriorityModal(props) {
    (0, _classCallCheck3.default)(this, PriorityModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PriorityModal.__proto__ || (0, _getPrototypeOf2.default)(PriorityModal)).call(this, props));

    _this.handleSave = function () {
      _this.setState({
        confirmLoading: true
      });
      var priorityData = _this.state.cards.map(function (card, index) {
        return {
          id: card.id,
          priority: index
        };
      });
      _this.props.rulesetsActions('updatePriorities', { priorityData: priorityData });
    };

    _this.handleCancel = function () {
      _this.props.togglePriorityModal();
    };

    _this.moveCard = function (dragIndex, hoverIndex) {
      var cards = _this.state.cards;

      var dragCard = cards[dragIndex];

      _this.setState((0, _update2.default)(_this.state, {
        cards: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
        }
      }));
    };

    _this.buildDraggableList = function () {
      var cards = _this.state.cards;

      if (cards.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: 'modal-empty-message-text' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'priorityModal.body.noRulesetText', defaultMessage: 'No Rulesets Available' })
        );
      }
      return cards.map(function (card, index) {
        return _react2.default.createElement(_Card2.default, {
          key: card.id,
          index: index,
          id: card.id,
          text: card.name,
          moveCard: _this.moveCard
        });
      });
    };

    _this.state = {
      cards: [],
      confirmLoading: false
    };
    return _this;
  }

  (0, _createClass3.default)(PriorityModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.visible) {
        if (this.props.ruleset.updatingRuleset !== nextProps.ruleset.updatingRuleset && !nextProps.ruleset.updatingRuleset) {
          this.setState({
            confirmLoading: false
          });
        }
      } else {
        this.setState({
          cards: nextProps.ruleset.rulesetData
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'priorityModal__component' },
        _react2.default.createElement(
          _antd.Modal,
          {
            visible: this.props.visible,
            width: 800,
            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'priorityModal.modal.title', defaultMessage: 'Drag to set Rule Set priorities' }),
            onOk: this.handleSave,
            maskClosable: false,
            okText: this.state.confirmLoading ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'priorityModal.saving.button.text', defaultMessage: 'Saving...' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'priorityModal.save.button.text', defaultMessage: 'Save' }),
            confirmLoading: this.state.confirmLoading,
            onCancel: this.handleCancel
          },
          _react2.default.createElement(
            'div',
            { style: { padding: '15px 15px 20px' } },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'priorityModal.body.priorityDescription',
              defaultMessage: 'Priorities determine which rules are executed when there are conflicts. If conditions are met for multiple rule sets which affect the same campaigns, then only the higher priority rule will be executed (where 1 = highest priority).'
            })
          ),
          this.buildDraggableList()
        )
      );
    }
  }]);
  return PriorityModal;
}(_react.Component), _class2.propTypes = {
  ruleset: _propTypes2.default.shape({
    rulesetData: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    updatingRuleset: _propTypes2.default.bool
  }).isRequired,
  togglePriorityModal: _propTypes2.default.func.isRequired,
  rulesetsActions: _propTypes2.default.func.isRequired,
  visible: _propTypes2.default.bool.isRequired
}, _temp)) || _class);
exports.default = PriorityModal;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/components/PriorityModal.js
// module id = 3692
// module chunks = 3